module.exports = __webpack_public_path__ + "static/media/keys.790fafde.svg";